import React, { useCallback, useMemo } from "react";
import { ToggleButton } from "components/buttons";
import { LayoutTabs } from "components/tabs/LayoutTabs";
import { Select } from "@/components/core/Select";
import { Tabs } from "components/tabs/Tabs";
import { SORT_TOP_OPTIONS, MANAGE_TABS } from "./constants";
import { getFilteredSortOptions } from "./helpers";
import "./FeedControl.scss";

interface IFeedControl {
  order: string;
  ordering?: boolean;
  orderingTop?: boolean;
  tiles?: boolean;
  verified?: boolean;
  isWithRecent?: boolean;
  topic?: string;
  topics?: boolean;
  changeTopic?: (topic: string) => void;
  changeOrder: (value: string) => void;
  changeMode?: (tiles: boolean) => void;
  changeVerified?: (verified: boolean) => void;
}

export const FeedControl: React.FC<IFeedControl> = ({
  order,
  ordering,
  orderingTop,
  tiles,
  verified,
  isWithRecent,
  topic,
  topics,
  changeOrder,
  changeMode,
  changeVerified,
  changeTopic
}) => {
  const sortOptions = useMemo(() => getFilteredSortOptions(!!isWithRecent), [isWithRecent]);

  const onModeToggle = useCallback(() => {
    if (changeMode) {
      changeMode(!tiles);
    }
  }, [changeMode, tiles]);

  const onVerifiedToggle = useCallback((value: boolean) => {
    if (changeVerified) {
      changeVerified(value);
    }
  }, [changeVerified]);

  const handleChangeOrder = (value: string | null) => {
    const newValue = value === "top" && orderingTop ? "best" : value;
    changeOrder(newValue as string);
  };

  return (
    <div className="FeedControl">
      <div className="FeedControl-Ordering">
        {ordering && (
          <Select
            label="Sort by"
            value={SORT_TOP_OPTIONS.find(item => item.value === order) ? "top" : order}
            list={sortOptions}
            onChange={handleChangeOrder}/>
        )}

        {ordering && orderingTop && SORT_TOP_OPTIONS.find(item => item.value === order) && (
          <Select
            value={order}
            list={SORT_TOP_OPTIONS}
            onChange={handleChangeOrder}
          />
        )}

        {changeVerified && (
          <div className="FeedControl-VerifyToggle">
            <ToggleButton
              className="small right"
              label="Verified only"
              checked={!!verified}
              onChange={onVerifiedToggle}
            />
          </div>
        )}
      </div>

      {topics !== false && topic && changeTopic &&
        <div className="FeedControl-Tabs">
          <Tabs value={topic} list={MANAGE_TABS} onChange={changeTopic}/>
        </div>
      }

      {!isWithRecent && (
        <div className="FeedControl-Layout">
          <LayoutTabs isGrid={!!tiles} onChangeLayout={onModeToggle} size="m" />
        </div>
      )}
    </div>
  );
};
